import { Box, styled } from "@mui/material";
export const GridAutoColumn2 = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(350px, 1fr))",
    gap: "1rem",
    gridTemplateRows: "auto",
    padding: "1rem 3rem",
    [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(1, minmax(350px, 1fr))",
    },
    [theme.breakpoints.between("sm", "md")]: {
        gridTemplateColumns: "repeat(2, minmax(350px, 1fr))",
    },
}));


export const GridAutoColumnForm2= styled("div")(({theme})=>({
    display:"grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap:"1rem",
    [theme.breakpoints.down('md')]:{
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        rowGap:"1rem",
    }
}))

export const FormLayoutGrid = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "45% 55%",
    gridTemplateRows: "auto",
    gap: "1rem",
    borderBottom: "1px solid"
}));